<!--
    校区管理-账户管理
    功能：展示账户列表数据
    说明：旧版
-->
<template>
  <div class="account" v-loading="loading">
    <div class="top">
      <div class="clearfix">
        <span class="title">账户剩余</span>

        <el-button class="pay_btn btn-gray" :size="schoolCenter ? '' : 'small'" @click="pay" v-if="$permissions('school_billing_account_pay')">充 值</el-button>
      </div>
      <div class="schoolCenter-surplus flex" v-if="schoolCenter">
        <dl class="flex ac jc">
          <dt class="fn" :style="`background: url(${require('./assets/surplus-1.png')})`"></dt>
          <dd>
            <p>音视频直播课堂1v1、1v2、1v3、1v4</p>
            <strong>{{ prepaid_card.school_teaching_1v4 | formatter }}分钟</strong>
          </dd>
        </dl>

        <dl class="flex ac jc" style="background: #6294F5;">
          <dt class="fn" :style="`background: url(${require('./assets/surplus-2.png')})`"></dt>
          <dd>
            <p>录制</p>
            <strong>{{ prepaid_card.school_record | formatter }}分钟</strong>
          </dd>
        </dl>

        <dl class="flex ac jc" style="background: #45CB90;">
          <dt class="fn" :style="`background: url(${require('./assets/surplus-3.png')})`"></dt>
          <dd>
            <p>回放</p>
            <strong>{{ prepaid_card.school_replay | formatter }}分钟</strong>
          </dd>
        </dl>

        <dl class="flex ac jc" style="background: #727DF4;">
          <dt class="fn" :style="`background: url(${require('./assets/surplus-4.png')})`"></dt>
          <dd>
            <p>金币</p>
            <strong>{{ prepaid_card.gold | formatter }}个</strong>
          </dd>
        </dl>
      </div>
      <div class="box" v-else>
        <div class="info_box">
          <div class="info">
            <h1>音视频直播课堂<br/>（1v1、1v2、1v3、1v4）</h1>
            <p>{{ prepaid_card.school_teaching_1v4 | formatter }}分钟</p>
          </div>
          <div class="info">
            <h1>录制</h1>
            <p>{{ prepaid_card.school_record | formatter }}分钟</p>
          </div>
          <div class="info">
            <h1>回放</h1>
            <p>{{ prepaid_card.school_replay | formatter }}分钟</p>
          </div>
        </div>
        <div class="gold_box">
          <div class="gold_info">
            <h1><i class="icon gold"></i>金币</h1>
            <p>{{ prepaid_card.gold | formatter }}个</p>
          </div>
        </div>
      </div>
    </div>

    <div class="search_box">
      <el-tabs class="month" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          v-for="(item, index) in month"
          v-if="item > 0"
          :key="index"
          :label="`${item}月份`"
          :name="item"></el-tab-pane>
      </el-tabs>
      <el-date-picker
        class="month_picker"
        v-model="dateValue"
        type="month"
        :size="schoolCenter ? '' : 'mini'"
        :picker-options="expireTimeOption"
        value-format="yyyy-MM"
        placeholder="选择其他月份"
        :clearable="false"
        @change="changeDate">
      </el-date-picker>
    </div>
    <div class="info">
      <div class="schoolCenter-title flex ac" v-if="schoolCenter">
        <h3>{{ day }}账单：</h3>
        <p>{{ monthstart }} 至 {{ monthend }}</p>
        <i></i>
        <span>每日上午7:00进行更新</span>
      </div>
      <div class="title" v-else>
        <p>{{ day }}账单（{{ monthstart }} ~ {{ monthend }}）</p>
        <p>
          <span>每日上午7:00进行更新</span>
        </p>
      </div>

      <div class="schoolCenter-count flex" v-if="schoolCenter">
        <div class="schoolCenter-count-item flex dc ac jc">
          <p>音视频直播课堂lv1、lv2、lv3、lv4</p>
          <strong>{{$setting.toDecimal(total.teaching, 2)}}分钟</strong>
        </div>

        <div class="schoolCenter-count-item flex dc ac jc">
          <p>录制</p>
          <strong style="color: #6294F5;">{{$setting.toDecimal(total.record, 2)}}分钟</strong>
        </div>

        <div class="schoolCenter-count-item flex dc ac jc">
          <p>回放</p>
          <strong style="color: #727DF4;">{{$setting.toDecimal(total.replay, 2)}}分钟</strong>
        </div>

        <div class="schoolCenter-count-item flex dc ac jc">
          <p>金币</p>
          <strong style="color: #9F5CE0;">{{$setting.toDecimal(total.gold, 2)}}个</strong>
        </div>
      </div>
      <el-table
        v-else
        class="count_box"
        ref="table"
        :data="[...total]"
        :border="true">
        <el-table-column
          prop="teaching"
          align="center"
          :label="`音视频直播课堂（1v1、1v2、1v3、1v4）`"
          :formatter="(row) => {
            return `${this.$setting.toDecimal(row.teaching, 2)}分钟`
          }"
        />
        <el-table-column
          prop="record"
          align="center"
          label="录制"
          :formatter="(row) => {
            return `${this.$setting.toDecimal(row.record, 2)}分钟`
          }"
        />
        <el-table-column
          prop="replay"
          align="center"
          label="回放"
          :formatter="(row) => {
            return `${this.$setting.toDecimal(row.replay, 2)}分钟`
          }"
        />
        <el-table-column
          prop="gold"
          align="center"
          label="金币"
          :formatter="(row) => {
            return `${this.$setting.toDecimal(row.gold, 2)}个`
          }"
        />
      </el-table>

      <div class="title">校区账单</div>
      <el-table
        ref="table"
        :data="list"
        :border="!schoolCenter"
      >
        <el-table-column
          v-for="col in columns"
          :key="col.prop"
          :prop="col.prop"
          :label="col.label"
          :width="col.width"
          :formatter="col.formatter"
        />
        <el-table-column
          width="120px"
          label="操作">
          <template slot-scope="scope">
            <template v-if="$permissions('school_billing_account_showBill')">
              <el-link
                v-if="schoolCenter"
                @click="bill(scope.row)"
              >校区账单</el-link>
              <el-button
                v-else
                size="small"
                @click="bill(scope.row)"
              >校区账单</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
  import baseUrl from "../../utils/api";
  import setting from "../../utils/setting";

  export default {
    name: "Account",
    data() {
      return {
        loading: false,
        activeName: '',
        day: '',
        monthstart: '',
        monthend: '',
        month: [],
        dateValue: '',
        expireTimeOption: {
          disabledDate(time) {
            return time.getTime() < 1585670400000;   //禁用2020-04以前的日期
          }
        },
        list: [],
        total: {
          cash: 0,
          gold: 0,
          teaching: 0,
          record: 0,
          replay:0
        },
        wallet: {
          cash_balance: '',
          gold_balance: ''
        },
        prepaid_card: {
          school_teaching_1v1: 0,
          school_teaching_1v2: 0,
          school_teaching_1v3: 0,
          school_teaching_1v4: 0,
          school_record: 0,
          school_replay: 0,
          gold: 0
        },
        columns: [
          { prop: 'name', label: '校区' },
          {
            label: '音视频直播课堂',
            formatter: row => {
              let num = 0;
              row.service.forEach(item => {
                if (item.code === 'school_teaching') {
                  num = item.number
                }
              })
              return `${this.$setting.toDecimal(num, 2)}分钟`
            }
          },
          {
            label: '录制',
            formatter: row => {
              let num = 0;
              row.service.forEach(item => {
                if (item.code === 'school_record') {
                  num = item.number
                }
              })
              return `${this.$setting.toDecimal(num, 2)}分钟`
            }
          },
          {
            label: '回放',
            formatter: row => {
              let num = 0;
              row.service.forEach(item => {
                if (item.code === 'school_replay') {
                  num = item.number
                }
              })
              return `${this.$setting.toDecimal(num, 2)}分钟`
            }
          },
          {
            label: '金币消费',
            formatter: row => `${setting.toDecimal(Number(row.total.gold_payment), 2)}个`
          }
        ],
        schoolCenter: this.$store.state.from === 'schoolCenter',
      }
    },
    filters: {
      formatter(val) {
        return setting.toDecimal(Number(val), 2);
      }
    },
    computed: {
      school() {
        return this.$store.state.choicesSchool
      }
    },
    created() {
      const today = this.$moment(new Date());
      const month = today.month() + 1; // 当前月份
      this.setTime(month, today);
      this.activeName = String(month);
      const date = [];
      for (let i = month; date.length < 3; i--) {
        date.push(String(i));
      }
      this.month = date;
    },
    methods: {
      handleClick(tab) {
        this.setTime(tab.name, this.$moment(new Date()));
      },
      changeDate(val) {
        this.activeName = '';
        this.setTime(this.$moment(val).month() + 1, val);
      },
      setTime(time, date) {
        const today = this.$moment(date).set('month', (time - 1) );
        this.day = today.format('YYYY年MM月');
        this.monthstart = today.startOf('month').format('YYYY-MM-DD'); // 当月第一天
        this.monthend = today.endOf('month').format('YYYY-MM-DD'); // 当月最后一天
        this.load(this.school.main_id, today.format('YYYY-MM'));
      },
      bill(row) { // 校区账单
        this.$router.push(`/account/bill/${row.id}`);
      },
      // 加载信息
      load(id, time) {
        this.loading = true;
        this.$http.get(`${baseUrl}/api/expense/main/${id}/detail/${time}?clients_id=${localStorage.getItem('school_id') || this.$store.state.choicesSchool.id}`)
          .then((res) => {
            this.total = {
              cash: 0,
              gold: 0,
              teaching: 0,
              record: 0,
              replay:0
            };
            this.total.gold = res.data.total.gold_payment; // 总计
            this.wallet = res.data.wallet; // 账户余额
            this.prepaid_card = res.data.prepaid_card;
            const data = res.data.clients.map(item => {
              let arr = [];
              for (let i in item.service) {
                for (let b in item.service[i].detail) {
                  arr.push(item.service[i].detail[b]);
                }
              }
              return {...item, service: arr}
            })
            this.list = data.filter(item => item.id !== 0);
            // 校区账单
            this.list.forEach(item => {
              item.service.forEach(b => {
                if (b.code === 'school_teaching') {
                  this.total.teaching += b.number
                } else if (b.code === 'school_record') {
                  this.total.record += b.number
                } else if (b.code === 'school_replay') {
                  this.total.replay += b.number
                }
              })
            })
          })
          .catch((err) => {
            this.$message.error(err.message);
          })
          .finally(() => {
            this.loading = false;
          });
      },
      // 充值
      pay() {
        this.$router.push('/account/pay');
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/reset.scss";
  @import "index";
</style>



// WEBPACK FOOTER //
// src/views/Account/index.vue